import { render, staticRenderFns } from "./editStaff.vue?vue&type=template&id=bf75a368&scoped=true&"
import script from "./editStaff.vue?vue&type=script&lang=js&"
export * from "./editStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf75a368",
  null
  
)

export default component.exports